/**
 * @generated SignedSource<<aaee83dd367d9781ca6633aa53b5a731>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConnectContactFormFieldConfig = "DISABLED" | "OPTIONAL" | "REQUIRED";
export type ConnectInboxAudience = "CUSTOMERS" | "EMPLOYEES";
export type ConnectInboxUpdateInput = {
  setAudience?: ConnectInboxAudience | null;
  setContactFormEmail?: ConnectContactFormFieldConfig | null;
  setContactFormName?: ConnectContactFormFieldConfig | null;
  setContactFormPhone?: ConnectContactFormFieldConfig | null;
  setContactFormPrompt?: string | null;
  setCustomTitle?: string | null;
  setDescription?: string | null;
  setSuccessMessage?: string | null;
  setTagIds?: ReadonlyArray<string> | null;
  setTeamIds?: ReadonlyArray<string> | null;
  setTodoCategoryId?: string | null;
  setWelcomeMessage?: string | null;
};
export type ConnectAdminInboxSaveMutation$variables = {
  id: string;
  input: ConnectInboxUpdateInput;
};
export type ConnectAdminInboxSaveMutation$data = {
  readonly store: {
    readonly connectInbox: {
      readonly update: {
        readonly connectInbox: {
          readonly audience: ConnectInboxAudience | null;
          readonly contactFormEmail: ConnectContactFormFieldConfig;
          readonly contactFormName: ConnectContactFormFieldConfig;
          readonly contactFormPhone: ConnectContactFormFieldConfig;
          readonly contactFormPrompt: string | null;
          readonly customTitle: string | null;
          readonly description: string | null;
          readonly successMessage: string | null;
          readonly tags: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly teams: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly todoCategory: {
            readonly id: string;
          } | null;
          readonly welcomeMessage: string | null;
        };
      };
    };
  };
};
export type ConnectAdminInboxSaveMutation = {
  response: ConnectAdminInboxSaveMutation$data;
  variables: ConnectAdminInboxSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customTitle",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "successMessage",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "welcomeMessage",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactFormName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactFormEmail",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactFormPhone",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactFormPrompt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategoryTag",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategory",
  "kind": "LinkedField",
  "name": "todoCategory",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectAdminInboxSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ConnectInboxMutations",
            "kind": "LinkedField",
            "name": "connectInbox",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "ConnectInboxUpdatePayload",
                "kind": "LinkedField",
                "name": "update",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConnectInbox",
                    "kind": "LinkedField",
                    "name": "connectInbox",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConnectAdminInboxSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ConnectInboxMutations",
            "kind": "LinkedField",
            "name": "connectInbox",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "ConnectInboxUpdatePayload",
                "kind": "LinkedField",
                "name": "update",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConnectInbox",
                    "kind": "LinkedField",
                    "name": "connectInbox",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e2716c3ed9ef26f1538033f1344d4223",
    "id": null,
    "metadata": {},
    "name": "ConnectAdminInboxSaveMutation",
    "operationKind": "mutation",
    "text": "mutation ConnectAdminInboxSaveMutation(\n  $id: ID!\n  $input: ConnectInboxUpdateInput!\n) {\n  store {\n    connectInbox(id: $id) {\n      update(input: $input) {\n        connectInbox {\n          audience\n          customTitle\n          description\n          successMessage\n          welcomeMessage\n          contactFormName\n          contactFormEmail\n          contactFormPhone\n          contactFormPrompt\n          teams {\n            id\n          }\n          tags {\n            id\n          }\n          todoCategory {\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0938c4ccbc9ff6192ee22a12faa2623";

export default node;
